// Amplify / Cognito groups
// https://us-east-1.admin.amplifyapp.com/admin/d3g9bq0hoaeu64/master/users/groups

export const SUPER_ADMIN = "SuperAdminCLI";
export const DASH_ADMIN = "DashboardAdmin";
export const DATE_FORMAT_CHART = 'dd MMM (H:mm)';
export const DATE_FORMAT_TABLE = 'dd MMM yyyy (H:mm)';
export const CELSIUS_PFX = '℃';
export const SET_HOURS_FROM = [0,0,0,0]
export const SET_HOURS_TO = [23, 59, 59, 0];
export const MAX_DAYS_RANGE = null
export const MIN_DAYS_RANGE = 1
